import { render, staticRenderFns } from "./AirportSubmitSlot.vue?vue&type=template&id=1f8d2b4c&"
import script from "./AirportSubmitSlot.vue?vue&type=script&lang=js&"
export * from "./AirportSubmitSlot.vue?vue&type=script&lang=js&"
import style0 from "./AirportSubmitSlot.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports